import { useTranslation } from 'react-i18next';
import Button from '../../components/Button';
import Input from '../../components/Input';
import SelectInput from '../../components/SelectInput';
import { GetChannelCategories } from '../../graphql/queries';
import { useMutation, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { UpdateChannelCategories } from '../../graphql/mutations';

const ChannelCategories = () => {

    const { t } = useTranslation()
    const { data, refetch } = useQuery(GetChannelCategories)
    const [update, { loading }] = useMutation(UpdateChannelCategories)
    const [items, setItems] = useState([])

    useEffect(() => {
        if (items?.length || !data?.getChannelCategories?.length) return

        setItems(data.getChannelCategories)
    }, [data])

    const handleItemChange = (e, item) => {
        const updatedItems = [...items]
        const index = updatedItems.findIndex(i => i.id === item.id)
        updatedItems[index] = { ...updatedItems[index], coefficient: e.target.value }
        setItems(updatedItems)
    }

    const displayTotal = (type) => {
        const total = items.filter(x => x.type === type).reduce((acc, curr) => acc + (curr?.coefficient? parseFloat(curr.coefficient) : 0), 0)
        return (
            <span className='total'>{`${t('settings.total')}: ${total}%`}</span>
        )
    }

    const handleUpdate = async () => {
        try {
            await update({ variables: { input: items.map(i => ({
                ...i,
                __typename: undefined,
                updatedAt: undefined,
                createdAt: undefined,
                coefficient: parseFloat(i.coefficient),
            })) } })
            refetch()
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div>
            <div className='settings-channel-categories'>
                <div className='settings-channel-categories--table'>
                    {
                        items?.length > 0 ?
                            items.map(x =>
                                <div key={`dist-${x.id}`} className='settings-channel-categories--item'>
                                    <h5>{t(x.name)}</h5>
                                    <div className='settings-channel-categories--coefficient'>
                                        <Input
                                            label={t('settings.coefficient')}
                                            type={'number'}
                                            value={x.coefficient}
                                            suffix={'%'}
                                            onChange={(e) => handleItemChange(e, x)}
                                        />
                                    </div>
                                </div>
                            )
                            :
                            <p>{t('settings.no_channel_categories')}</p>
                    }
                    <div className='settings-channel-categories--total'>
                        {displayTotal('TV')}
                    </div>
                    <Button
                        label={t('settings.save')}
                        onClick={handleUpdate}
                        loading={loading}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default ChannelCategories